import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './SupabaseAuthContext';

const SoundContext = createContext();

const SOUND_KEY = 'footparadise_sound_muted';

// Per-account, like DarkModeContext — see comment there.
function readStored(userId) {
  return localStorage.getItem(`${SOUND_KEY}::${userId}`) === 'true';
}

export function SoundProvider({ children }) {
  const { user } = useAuth();
  const userId = user?.id || 'guest';
  const [isMuted, setIsMuted] = useState(() => readStored(userId));

  useEffect(() => {
    setIsMuted(readStored(userId));
  }, [userId]);

  const toggleMute = () => {
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    localStorage.setItem(`${SOUND_KEY}::${userId}`, newMuted.toString());
  };

  const setMuted = (muted) => {
    setIsMuted(muted);
    localStorage.setItem(`${SOUND_KEY}::${userId}`, muted.toString());
  };

  return (
    <SoundContext.Provider value={{ isMuted, toggleMute, setMuted }}>
      {children}
    </SoundContext.Provider>
  );
}

export function useSound() {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSound must be used within a SoundProvider');
  }
  return context;
}
